<div [class]="classe" class="overflow-hidden mt-0">
    <p-accordion
        (onClose)="onClose($event)"
        (onOpen)="onOpen($event)"
        [value]="isPanelOpen ? ['item-1'] : []"
        [multiple]="true"
    >
        <p-accordion-panel value="item-1" class="mt-0">
            <p-accordion-header class="py-1! px-3!"
                [ngClass]="isPanelOpen
                    ? 'bg-primary! text-gray-100! font-semibold!'
                    : 'bg-slate-200! text-gray-950! font-semibold!'"
            >
                {{ title }}
            </p-accordion-header>

            <p-accordion-content class="overflow-x-auto"
                [style.--p-accordion-content-background]="bgColor || null"
            >
                <ng-content></ng-content>
                <div class="mt-8">
                    <ng-content select="[lista]"></ng-content>
                </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
</div>